import { useEffect, useState } from "react";
import { Share2, RefreshCw } from "lucide-react";
import api, { apiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";

export default function SocialHistory({ businessId }) {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let active = true;
    setItems([]); setError(""); setLoading(true);
    api.get("/social/history", { params: businessId ? { business_id: businessId } : {} })
      .then(({ data }) => { if (active) setItems(data || []); })
      .catch((failure) => { if (active) setError(apiError(failure)); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [businessId, revision]);
  return <section data-testid="social-history-card" className="bg-[#FFFFFF] border border-[#E2E8F0] rounded-2xl p-4 sm:p-6 lg:col-span-2 space-y-3">
    <div className="flex flex-wrap justify-between gap-2"><h2 className="font-heading font-bold flex gap-2 items-center"><Share2 size={18} />Riwayat Posting Sosial Media</h2><Button type="button" variant="outline" disabled={loading} onClick={() => setRevision((value) => value + 1)} aria-label="Muat ulang riwayat sosial"><RefreshCw size={14} /></Button></div>
    {error && <p role="alert" className="text-xs text-red-600">{error}</p>}
    {loading && <p className="text-xs text-slate-600">Memuat riwayat...</p>}
    {!loading && !error && !items.length && <p data-testid="social-history-empty" className="text-xs text-slate-600">Belum ada posting sosial media.</p>}
    {items.map((item) => <div key={item.id} className="rounded-xl bg-[#F1F5F9] p-3 space-y-1 text-xs" data-testid={`social-history-${item.id}`}>
      <p className="text-slate-600">{new Date(item.created_at).toLocaleString("id-ID")} · {item.by_user}</p>
      <p className="break-words">{item.text}</p>
      {(item.targets || []).map((target) => <p key={target} className={item.results?.[target]?.ok ? "text-emerald-600" : "text-red-600"}>{target}: {item.results?.[target]?.ok ? "Berhasil" : item.results?.[target]?.error || "Gagal"}</p>)}
    </div>)}
  </section>;
}
